<template>
  <EditorTitleOverlay class="absolute top-0 left-0 right-0 z-50 justify-between">
    <ChevronLeftIcon class="w-5 h-5 mr-4 cursor-pointer" data-testid="back-btn" @click.stop="$emit('back')" />

    <div class="flex-1 text-lg text-center truncate max-w-4/5">{{ layerBreadcrumbs }}</div>
  </EditorTitleOverlay>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue'
import { computed } from 'vue'
import { ChevronLeftIcon } from '@heroicons/vue/24/outline'

import type { LayerSceneElement } from '~/entities/model3d'
import type { LayerGroup } from '~/composables/useThreeDViewer'
import { DEFAULT_CATEGORY } from '~/lib/three-d-viewer/layer-utils'
import type { Layer } from '~/composables/useThreeDLayerGroups'

const props = defineProps({
  scopingElement: {
    type: Object as PropType<LayerSceneElement>,
    required: true,
  },
  layerGroups: {
    type: Array as PropType<LayerGroup[]>,
    required: true,
  },
})

defineEmits(['back'])

const categoryName = computed(() => {
  return (
    props.layerGroups
      .map(layerGroup => {
        const layer = (<Layer[]>layerGroup.layers).find(layer => layer.nodeId === props.scopingElement.nodeId)

        if (layer) {
          return { ...layer, categoryName: layerGroup.name }
        }
      })
      .filter(x => !!x)[0]?.categoryName ?? 'Category Name'
  )
})

const layerBreadcrumbs = computed(() => {
  if (categoryName.value && categoryName.value !== DEFAULT_CATEGORY) {
    return `${categoryName.value} > ${props.scopingElement.title}`
  }

  return `${props.scopingElement.title}`
})
</script>
